import React from 'react';
import classes from "./ErrorBoundary.module.css";
import { useNavigate, useRouteError } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa6";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import Container from '../component/Container';

const ErrorBoundary = () => {
    const error = useRouteError();
    const navigate = useNavigate();
    return (
        <Layout>
            <SubLayout>
                {/* <Header active={null} /> */}
                <Container>
                    <div className={classes.header_section}>
                        <div className={classes.back_button} onClick={() => {
                            navigate(-1);
                        }}>
                            <FaArrowLeft className={classes.back_icon} />
                        </div>

                        <h2 className={classes.header_text}>Some Error Occured!</h2>
                    </div>

                    <div className={classes.message_box}>
                        <div className={classes.message_container}>
                            <p className={classes.text}>{error?.message || "Unknown Error"}</p>
                        </div>
                    </div>

                    <div className={classes.btn_container}>
                        <button type='button' className={classes.btn} onClick={() => window.location.reload()}>
                            Refresh Page
                        </button>
                    </div>

                </Container>
            </SubLayout>
        </Layout>
    )
}

export default ErrorBoundary